// Vec3 minimalista e mutável para o hot path da física (sem dependência de three).
export interface V3 { x: number; y: number; z: number }

export const v3 = (x = 0, y = 0, z = 0): V3 => ({ x, y, z });
export const copy = (out: V3, a: V3): V3 => { out.x = a.x; out.y = a.y; out.z = a.z; return out; };
export const set = (out: V3, x: number, y: number, z: number): V3 => { out.x = x; out.y = y; out.z = z; return out; };
export const add = (out: V3, a: V3, b: V3): V3 => { out.x = a.x + b.x; out.y = a.y + b.y; out.z = a.z + b.z; return out; };
export const sub = (out: V3, a: V3, b: V3): V3 => { out.x = a.x - b.x; out.y = a.y - b.y; out.z = a.z - b.z; return out; };
export const scale = (out: V3, a: V3, s: number): V3 => { out.x = a.x * s; out.y = a.y * s; out.z = a.z * s; return out; };
export const addScaled = (out: V3, a: V3, b: V3, s: number): V3 => {
  out.x = a.x + b.x * s; out.y = a.y + b.y * s; out.z = a.z + b.z * s; return out;
};
export const dot = (a: V3, b: V3): number => a.x * b.x + a.y * b.y + a.z * b.z;
export const cross = (out: V3, a: V3, b: V3): V3 => {
  const x = a.y * b.z - a.z * b.y, y = a.z * b.x - a.x * b.z, z = a.x * b.y - a.y * b.x;
  out.x = x; out.y = y; out.z = z; return out;
};
export const len = (a: V3): number => Math.hypot(a.x, a.y, a.z);
export const len2D = (a: V3): number => Math.hypot(a.x, a.z);
export const normalize = (out: V3, a: V3): V3 => {
  const l = len(a);
  return l > 1e-8 ? scale(out, a, 1 / l) : set(out, 0, 0, 0);
};
